export default {
  base: {
    header: {
      span: {
        variant: 'spark.elements.type.button1',
        fontWeight: 'bold'
      }
    },
    span: {
      variant: 'spark.elements.type.body3'
    }
  }
};